import React from "react";
import PropTypes from "prop-types";
import { ReachMenu, ReachMenuList, ReachMenuButton, ReachMenuItem, ReachMenuLink } from "./menu-button-pieces";
import Icon from "./icon";
import classNames from "classnames";
import uuid from "uuid/v4";

const ActionsMenu = ({ trigger, options, menuClassName, triggerClassName, title, disabled, contentWidth }) => {
  const [mounted_item, setMountedItem] = React.useState(null);

  return (
    <>
      <ReachMenu>
        {({ isOpen }) => (
          <>
            <ReachMenuButton
              disabled={disabled}
              title={title}
              className={classNames(
                {
                  "et--actions-menu--trigger et--button-action": !trigger,
                  "et--plain-button": trigger,
                },
                triggerClassName
              )}
            >
              {typeof trigger === "function" ? (
                trigger({ isOpen, disabled })
              ) : (
                <span>
                  Actions...
                  <Icon icon={isOpen ? "chevron-up" : "chevron-down"} />
                </span>
              )}
            </ReachMenuButton>
            <ReachMenuList
              className={classNames("et--actions-menu--menu", menuClassName)}
              style={{ width: contentWidth }}
            >
              {options.map((option, index) => {
                const contents = (
                  <React.Fragment>
                    {option.icon && <Icon icon={option.icon} />}
                    {option.label}
                  </React.Fragment>
                );
                return option.href ? (
                  <ReachMenuLink
                    key={uuid()}
                    className="et--actions-menu--menu-option is-link"
                    as={option.as}
                    to={option.href}
                    target={option.target}
                    title={option.title}
                  >
                    {contents}
                  </ReachMenuLink>
                ) : (
                  <ReachMenuItem
                    title={option.title}
                    key={uuid()}
                    className="et--actions-menu--menu-option is-button"
                    onSelect={() => {
                      if (typeof option.mountOnClick === "function") {
                        setMountedItem(
                          option.mountOnClick({
                            is_open: true,
                            close: () => setMountedItem(null),
                          })
                        );
                      } else {
                        option.onClick();
                      }
                    }}
                  >
                    {contents}
                  </ReachMenuItem>
                );
              })}
            </ReachMenuList>
          </>
        )}
      </ReachMenu>
      {mounted_item && mounted_item}
    </>
  );
};

ActionsMenu.propTypes = {
  options: PropTypes.array,
  trigger: PropTypes.func,
  triggerClassName: PropTypes.string,
  title: PropTypes.string,
  menuClassName: PropTypes.string,
  disabled: PropTypes.bool,
  contentWidth: PropTypes.number,
};

export default ActionsMenu;
